import apiFetch from '../apiFetch'

export default function (documentHistoricalId, infoIncome, token) {
  return apiFetch({ endPoint: `documentHistorical/${documentHistoricalId}`, method: 'PUT', body: infoIncome, token: token })
}
